module.exports = __webpack_public_path__ + "img/solo1.05639fa0.png";